module.exports = __webpack_public_path__ + "static/media/RateUs.acf34739.svg";